'use client';

import React from 'react';

// Комментарий на русском: компонент выбора микрофона

interface VoiceDevicePickerProps {
  devices: MediaDeviceInfo[];
  selectedId: string | null;
  onChange: (deviceId: string) => void;
  disabled?: boolean;
}

export function VoiceDevicePicker({ devices, selectedId, onChange, disabled }: VoiceDevicePickerProps) {
  if (devices.length === 0) {
    return (
      <div className="text-sm text-site-muted dark:text-site-muted">
        Микрофоны не найдены
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1">
      <label className="text-xs text-site-muted dark:text-site-muted">Микрофон</label>
      <select
        value={selectedId || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="w-full px-3 py-2 text-sm rounded-lg border border-site-border dark:border-site-border-control
                   bg-site-surface dark:bg-site-surface text-site-muted dark:text-site-text
                   focus:ring-2 focus:ring-site-accent focus:border-transparent
                   disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {devices.map((device) => (
          <option key={device.deviceId} value={device.deviceId}>
            {device.label || `Микрофон ${device.deviceId.slice(0, 8)}`}
          </option>
        ))}
      </select>
    </div>
  );
}
